import { Controller, Loader, IDynamicLoader } from '@tencent/workbench';
import { ANGLE_MIN, FORM_CONFIGS } from '@framework/workbench/drawer/ui/layout/rotate/config';
import { AngleFrom, DragAngleCircleType, Form } from '@tencent/wb-ext-form';
import { FormItemName, IMultiDiffValue, INPUT_PROPS_CALLBACK_KEY } from '@framework/workbench/drawer/constants';
import { IRotateFeature } from '@framework/workbench/drawer/ui/layout/rotate/rotate-interface';
import { ANGLE_MAX } from '@framework/workbench/drawer/common/config';

@Controller({ formItems: FORM_CONFIGS })
export class RotateController {
    constructor(@Loader(IRotateFeature) private loader: IDynamicLoader<IRotateFeature>) {}

    private get feature() {
        return this.loader.instance!;
    }

    @Form(FormItemName.LAYOUT_ROTATE, 'value')
    public getAngle(): number | IMultiDiffValue {
        const rotateObj = { rotate: this.feature.rotate };
        return this.feature.getShownValue(INPUT_PROPS_CALLBACK_KEY.ROTATE, rotateObj);
    }

    @Form(FormItemName.LAYOUT_ROTATE, 'onChange')
    public changeAngle(value: number, from: AngleFrom, dragState?: DragAngleCircleType): void {
        const { rotate } = this.feature.getValidValue({ rotate: value }, from, ANGLE_MAX, ANGLE_MIN);
        this.feature.handleRotateChange(rotate, from, dragState);
    }
}
